import { Component } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-announcement-banner',
    templateUrl: './announcement-banner.component.html',
    styleUrls: ['./announcement-banner.component.scss']
})
export class AnnouncementBannerComponent {

    private readonly localStorageKey: string = 'announcementBannerVisible';

    public bannerVisible = new BehaviorSubject(
        localStorage.getItem(this.localStorageKey) !== 'false'
    );

    public closeAnnouncementBanner(): void {
        localStorage.setItem(this.localStorageKey, 'false');
        this.bannerVisible.next(false);
    }
}
